import MathHtml from 'components/imported-assessment/MathHtml'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Radio from '@mui/material/Radio'
import RadioGroup from '@mui/material/RadioGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import Checkbox from '@mui/material/Checkbox'

const useStyles = makeStyles(multipleChoiceStyles)

export default function MultipleChoice ({context, section, question, questionIndex}) {

  const classes = useStyles()
  const {translate, quizAssessmentToTake: assessment} = context

  const answer = assessment.answers[question.id] || {}

  const {properties} = question

  const choices = !properties.shuffle && question.answer.choices || answer.choices || []

  const {selected = null, selectedOptions = []} = answer

  const Choices = question.properties.singleOption ? RadioChoice : CheckboxChoice

  return (
    <Box className={classes.root}>
      {choices.length > 0 && (
        <Choices
          question={question}
          context={context} 
          choices={choices}
          selected={selected}
          selectedOptions={selectedOptions}
        />)}
    </Box>
  )
}

function RadioChoice ({context, question, choices, selected}) {

  const classes = useStyles()

  async function handleChange(e) {

    const value = e.target.value
    const {assessment: assessmentId} = context

    const {quizAssessmentToTake: {answers}} = await context.updateState({quizAssessmentToTake: {
      answers: {[question.id]: {
        selected: {$set: value},
        completed: {$set: true},
    }}}})

    context.saveAnswers({id: assessmentId, answers})
  }

  return (
    <RadioGroup className={clsx("choices", "radio")} value={selected} onChange={handleChange}>
      {choices.map((choice, index) => {
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97)
        return (
          <Box key={index} className={classes.option}>
            <Box className={classes.radio}>
              <FormControlLabel
                value={choice.id}
                className="choice"
                control={<Radio color="primary" />}
                label={(
                  <Box className={classes.optionLabel}>
                    <Box className="index">{answerIndex})</Box>
                    {context.importedMath ? <MathHtml className="choice-caption" html={choice.html || ''} /> : <div className="choice-caption" dangerouslySetInnerHTML={{__html: choice.html || ''}} />}
                  </Box>
                )}
              />
            </Box>
          </Box>
        )
      })}
    </RadioGroup>
  )
}

function CheckboxChoice ({context, question, choices, selectedOptions}) {

  const classes = useStyles()

  const {assessment: assessmentId} = context

  async function handleChange(id, checked) {

    const value = checked
      ? [...selectedOptions, id]
      : selectedOptions.filter(o => o != id)

    const completed = value.length > 0

    const {quizAssessmentToTake: {answers}} = await context.updateState({quizAssessmentToTake: {
      answers: {[question.id]: {
        selectedOptions: {$set: value},
        completed: {$set: completed}
      }}}})
      context.saveAnswers({id: assessmentId, answers})
  }

  return (
    <FormGroup className={clsx("choices", "checkbox")}>
      {choices.map((option, index) => {
        const answerIndex = String.fromCharCode(Math.min(index, 20) + 97)
        return (
        <Box key={index} className={classes.option}>
          <Box className={classes.checkbox}>
            <FormControlLabel
              control={<Checkbox color="primary" checked={selectedOptions.indexOf(option.id) >= 0} onChange={e => handleChange(option.id, e.target.checked)} />}
              label={(
                <Box className={classes.optionLabel}>
                  <Box className="index">{answerIndex})</Box>
                  {context.importedMath ? <MathHtml className="choice-caption" html={option.html || ''} /> : <div className="choice-caption" dangerouslySetInnerHTML={{__html: option.html || ''}} />}
                </Box>
              )}
            />
          </Box>
        </Box>
      )
      })}
    </FormGroup>
  )
}

function multipleChoiceStyles (theme) {
  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      flexWrap: 'wrap',
      paddingLeft: 10,
      fontSize: '12pt',
    },
    option: {
      display: 'flex'
    },
    optionLabel: {
      display: 'flex',
      "& > .index": {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        marginRight: 15
      }
    }
  }
}
